import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/notification/markRead/notification.markRead.mutation.gql"
import type {
  StaffNotificationsMarkReadMutation,
  StaffNotificationsMarkReadMutationVariables,
} from "@/v2-backoffice-client/notification/markRead/__types__/notification.markRead.mutation"

type Options = MutationHookOptions<
  StaffNotificationsMarkReadMutation,
  StaffNotificationsMarkReadMutationVariables
>

export function useStaffNotificationsMarkReadMutation(options?: Options) {
  return useMutation<
    StaffNotificationsMarkReadMutation,
    StaffNotificationsMarkReadMutationVariables
  >(mutation, {
    // Refetch by operation name so every active consumer (the feed page
    // and the always-mounted sidebar bell) updates, whatever variables
    // they were mounted with.
    refetchQueries: [
      "StaffNotificationsQuery",
      "StaffNotificationUnreadCountQuery",
    ],
    ...options,
  })
}
